import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClosedByteChannelExceptionClass;
function ClosedByteChannelException() {
  if (ClosedByteChannelExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(cause) {
        return new.target.c4k(cause);
      }
      static c4k(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.l4i(cause == null ? null : cause.message, cause);
        captureStack($this, $this.b4k_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedByteChannelException', $.c4k);
    ClosedByteChannelExceptionClass = $;
  }
  return ClosedByteChannelExceptionClass;
}
var ClosedReadChannelExceptionClass;
function ClosedReadChannelException() {
  if (ClosedReadChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.q4j(cause);
      }
      static q4j(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.c4k(cause);
        captureStack($this, $this.p4j_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedReadChannelException', $.q4j);
    ClosedReadChannelExceptionClass = $;
  }
  return ClosedReadChannelExceptionClass;
}
var ClosedWriteChannelExceptionClass;
function ClosedWriteChannelException() {
  if (ClosedWriteChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.w4j(cause);
      }
      static w4j(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.c4k(cause);
        captureStack($this, $this.v4j_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedWriteChannelException', $.w4j);
    ClosedWriteChannelExceptionClass = $;
  }
  return ClosedWriteChannelExceptionClass;
}
//region block: exports
export {
  ClosedByteChannelException as ClosedByteChannelException3il8gfpye60w,
  ClosedReadChannelException as ClosedReadChannelException9jdpzh6uy12w,
  ClosedWriteChannelException as ClosedWriteChannelException1eeenxj0c4bxu,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
